<nav class="nav-bar">
    <label for="menu-toggle" class="menu-icon" (click)="openMenu()">&#9776;</label>
    <ul class="menu" [ngClass]="{'mobile':isOpen}">
      <li *ngFor="let li of _ss.navMenu; index as i">
        <a [routerLink]="[li.url]" [routerLinkActive]="['is-active']">{{ li.title }}</a>
      </li>
    </ul>
  </nav>
  